import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { fg } from '@confluence/feature-gating';
import { LoadablePaint } from '@confluence/loadable';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

const LazyChatRoute = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Chat" */ '@confluence/chat/entry-points/Chat.ts'))
			.Chat,
});

export const ChatRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	if (!fg('rovo_search_chat_convergence')) {
		return <Redirection name={HOME.name} />;
	}

	return <LazyChatRoute />;
};

ChatRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'chatScreen' },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
	},
});
